//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientGraphQLAuthMutation } from 'Core/data/GraphQLApi';
import { LogManager, ExceptionManager } from 'Core/logManager';

//Action types
import {
    MIGRATE_USER_SEND,
    MIGRATE_USER_CONFIRM
} from 'Redux/actionTypes';

//actions
import {
    login,
    updateTermsAndCondition,
    migrateUserResult,
    migrateUserConfirmResult,
    clearRedux,
    loginConfirmResult,
    codeVerificationResult,
    logout
} from 'Redux/actions';

import {
  setCookie
} from 'Core/views/login/helper';
import { CODE_VERIFICATION } from './actionTypes';
/* FUNTIONS ASYNC */
function* migrateUserRequest({ payload }) {
    try {
        const { username, code, password, navigate } = payload

        let data = yield call(
            clientGraphQLAuthMutation,
            `
                mutation (
                    $code: String!
                    $password: String!
                    $username: String!
                ){
                    result: verifyUser (
                        username: $username
                        code: $code
                        password: $password
                    ) {
                        success
                        message
                    }
                }
            `,
            {
                username,
                code,
                password
            }
        );
        if (data?.result?.success) {
            //remove local preferences
            localStorage.removeItem("preferencesUser")
            localStorage.removeItem("preferencesCompany")
            localStorage.removeItem("preferencesOther")
            yield put(login({username: username.trim(), password: password.trim(), navigate}));
            yield put(updateTermsAndCondition({username: username.trim(), password: password.trim()}));
            LogManager(`User: ${username}`);
        } else {
            //yield put(migrateUserResult(null, data?.result?.message));
            yield put(migrateUserConfirmResult(false, data?.result?.message));
        }
    } catch (exc) {
        // catch throw
        ExceptionManager(exc, 'Core/views/migrateUser/redux', 'forgotPasswordRequest')
        yield put(migrateUserResult(null, exc.toString()));

    }
}

function* migrateUserConfirmRequest({ payload }) {
    try {
        const { username, cognitoValues, code, navigate } = payload
        
        let data = yield call(
            clientGraphQLAuthMutation,
            `
                mutation ($accessToken: String!, $code: String!){
                   result: verifyEmail (
                        accessToken: $accessToken
                        code: $code
                    )
                }
            `,
            {
                accessToken: cognitoValues.AccessToken,
                code: code.toString()
            }
        );

        if (data && data.result) {
            if(cognitoValues?.termAndCondition){
                navigate('/');
                yield put(login({username: username.trim(), password: cognitoValues?.password, navigate}));
                yield put(updateTermsAndCondition({username: username.trim(), password: cognitoValues?.password}));
            }else{
                localStorage.setItem("AccessToken", cognitoValues.AccessToken)
                localStorage.setItem("RefreshToken", cognitoValues.RefreshToken)
                localStorage.setItem("IdToken", cognitoValues.IdToken)
                setCookie("GPSTSharedOAUTHToken", cognitoValues.IdToken, 1)
                localStorage.setItem("username", username)
                //remove local preferences
                localStorage.removeItem("preferencesUser")
                localStorage.removeItem("preferencesCompany")
                localStorage.removeItem("preferencesOther")
               
                navigate('/');
                yield put(migrateUserConfirmResult(true));
                yield put(clearRedux("MIGRATE_USER")); 
            }
        } else {
            yield put(migrateUserConfirmResult(false, data.errorMessage));
        }
    } catch (exc) {
        // catch throw
        ExceptionManager(exc, 'Core/views/migrateUser/redux', 'forgotPasswordConfirmRequest')
        yield put(migrateUserConfirmResult(false, exc.toString()));

    }
}

function* codeVerificationRequest({ payload }) {
    const { username, code, navigate, isResetPassword } = payload
    try {
        
        
        let data = yield call(
            clientGraphQLAuthMutation,
            `
                query ($code: String!, $username: String!, $type: enumCodeType){
                    result: validateCode(
                        code: $code
                        username: $username
                        type: $type
                    ) {
                        registrationStatus
                        isValid
                    }
                }
            `,
            {
                username: username,
                code: code.toString(),
                type: isResetPassword ? "forgotPassword" : "verifyEmail"
            }
        );

        if(isResetPassword){
            if(data?.result?.isValid) {
                yield put(codeVerificationResult());
            } else {
                navigate("/")
                yield put(loginConfirmResult("migrateUser_codeNotValid"))
            }
        }else {
            if (!data?.result?.registrationStatus || data?.result?.registrationStatus != "Pending" || !data?.result?.isValid) {
                navigate("/")
                if(data?.result.registrationStatus == "Active"){
                    yield put(loginConfirmResult("migrateUser_userIsActive"));
                } else {
                    yield put(loginConfirmResult("migrateUser_userCodeExpired"));
                }
                yield put(logout());
                yield put(clearRedux("MIGRATE_USER"));
            } else {
                yield put(codeVerificationResult()); 
            }
        }
        
    } catch (exc) {
        // catch throw
        ExceptionManager(exc, 'Core/views/migrateUser/redux', 'codeVerificationRequest')
        navigate("/")
        yield put(loginConfirmResult("migrateUser_codeNotValid"))
    }
}



function* watchVerificationCodeRequest() {
    yield takeEvery(CODE_VERIFICATION, codeVerificationRequest);
}


function* watchMigrateUserRequest() {
    yield takeEvery(MIGRATE_USER_SEND, migrateUserRequest);
}


//merge sagas
export default function* rootSaga() {
    yield all([
        fork(watchMigrateUserRequest),
        fork(watchVerificationCodeRequest)
        

    ]);
}